import React from "react";
import styles from "./statTiles.module.css";

const LOADING_PLACEHOLDER = "--";

const StatTiles = ({
  items = [],
  columns = 2,
  className = "",
  loading = false,
}) => {
  return (
    <div
      className={[styles.grid, className].filter(Boolean).join(" ")}
      style={{ gridTemplateColumns: `repeat(${columns}, 1fr)` }}
      aria-busy={loading || undefined}
    >
      {items.map(({ id, label, value, color, valueColor, onClick }) => {
        const isClickable = Boolean(onClick) && !loading;

        return (
          <div
            key={id || label}
            className={[styles.tile, isClickable && styles.clickable]
              .filter(Boolean)
              .join(" ")}
            onClick={isClickable ? onClick : undefined}
          >
            <strong
              className={[styles.value, loading && styles.blink]
                .filter(Boolean)
                .join(" ")}
              style={loading ? undefined : { color: color ?? valueColor }}
            >
              {loading ? LOADING_PLACEHOLDER : value}
            </strong>
            <span className={styles.label}>{label}</span>
          </div>
        );
      })}
    </div>
  );
};

export default StatTiles;